import { SendMessageGuard } from "../guards/send-message-guard.service";
import { SendMessageContainerComponent } from "./send-message-container/send-message-container.component";

export const sidebarSendMessageRoutes = {
  path: "send-message",
  component: SendMessageContainerComponent,
  canActivate: [SendMessageGuard],
};
